export default __webpack_public_path__ + "static/media/portrait-square-05.b396923d.jpeg";